import { blogAxios } from "./blogAxios";

export const uploadFile = (file) => {
  const url = "/file/upload";
  const formData = new FormData();
  formData.append("file", file);
  formData.append("folder", "photos");

  return blogAxios
    .post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(({ data }) => data.data);
};
